import { getVipTitleByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import classNames from "classnames";
import { isExpVip } from "../Vip/shared/utils";
import styles from "./index.module.less";

interface VipTagProps {
  className?: string;
}

export default function VipTag(props: VipTagProps) {
  const { user } = useAppStore(({ user }) => ({ user }));
  const vipTagTitle = getVipTitleByUser(user);

  // 未开通与已过期返回 null
  if (!vipTagTitle) {
    return null;
  }

  return (
    <span
      className={classNames(styles.vipTag, props.className, {
        [styles.gray]: isExpVip(user),
      })}
    >
      {vipTagTitle}
    </span>
  );
}
